module.exports = __webpack_public_path__ + "img/event_icon_festival_white.6b105e23.png";